import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';
import { grayIconFill } from '../../../../../styles/colors';

const { colors, common, spacing } = THEME;

export const styleSheet = StyleSheet.create({
	externalAssociationInline: {
		color: grayIconFill,
		fontSize: 12,
		fontStyle: 'italic',
	},
	errorIcon: {
		marginLeft: 4,
		cursor: 'pointer',
	},
	timelineContainer: {
		marginTop: spacing.md,
	},
	timelineItemList: {},
	timelineItemContainer: {
		display: 'grid',
		gridTemplateColumns: '70px 16px 1fr',
	},
	timelineItemTime: {
		fontSize: 12,
		fontWeight: 500,
		color: colors.text.light,
		paddingTop: 27,
	},
	timelineItemLine: {
		height: '100%',
		backgroundColor: colors.border.light,
		width: 1,
		position: 'relative',
	},
	timelineItemLineIcon: {
		position: 'absolute',
		top: 25,
		left: -8,
		width: 16,
		height: 16,
		borderRadius: '50%',
		border: common.border,
		backgroundColor: colors.background.light,
	},
	timelineItemDate: {
		marginBottom: spacing.sm,
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
	},
	timelineItemDateAgo: {
		fontSize: 16,
		fontWeight: 500,
	},
	timelineItemDateText: {
		fontSize: 12,
		color: colors.text.light,
		alignSelf: 'flex-end',
	},
	timelineItemContent: {
		marginBottom: spacing.md,
	},
	timelineItemCard: {
		backgroundColor: colors.background.main,
		borderRadius: 8,
		padding: spacing.md,
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
		container: 'timelineCard / inline-size',
	},
	timelineItemActionItemOverdue: {
		border: `1px solid ${colors.warning.main}`,
		backgroundColor: colors.warning.light,
	},

	timelineItemCardIcon: {
		display: 'flex',
		alignItems: 'flex-start',
		paddingTop: THEME.spacing.sm,
	},
	timelineItemCardMainContent: {
		display: 'grid',
		gap: spacing.xs,
		'@container timelineCard (min-width: 300px)': {
			gridTemplateColumns: '24px 1fr 101px',
		},
		'@container timelineCard (min-width: 600px)': {
			gridTemplateColumns: '24px 1fr 160px',
		},
		'@container timelineCard (min-width: 700px)': {
			gridTemplateColumns: '24px 1fr 182px',
		},
	},
	timelineItemCardContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		minWidth: 0, // Allows flex item to shrink below its content size
		gap: spacing.xs,
	},
	timelineItemCardContentTitle: {},
	timelineItemCardContentTitleText: {
		fontSize: 14,
		fontWeight: 500,
		display: 'block',
		wordBreak: 'break-word',
		overflowWrap: 'break-word',
	},
	timelineItemCardContentSubtitle: {
		fontSize: 12,
		color: colors.text.light,
	},
	timelineItemCardContentSubtitleText: {
		fontSize: 12,
		color: colors.text.main,
		display: 'block',
		wordBreak: 'break-word',
		overflowWrap: 'break-word',
	},
	timelineItemCardAction: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	chevronDown: {
		transition: 'transform 0.2s ease-in-out',
	},
	chevronDownOpen: {
		transform: 'rotate(180deg)',
	},
	timelineItemExtraContentContainer: {
		height: 0,
		overflow: 'hidden',
		transition: 'height 0.2s ease-in-out',
	},
	timelineItemExtraContentContainerOpen: {
		height: 'auto',
		overflow: 'visible',
	},
	seeMoreButton: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.xs,
		padding: 0,
		paddingRight: spacing.xs,
		justifyContent: 'center',
	},
	seeMoreButtonIcon: {
		display: 'block',
		paddingTop: spacing.xs,
		'@container timelineCard (min-width: 600px)': {
			display: 'none',
		},
		'@container timelineCard (min-width: 700px)': {
			display: 'block',
		},
	},
	seeMoreButtonText: {
		display: 'none',
		'@container timelineCard (min-width: 600px)': {
			display: 'block',
		},
		'@container timelineCard (min-width: 700px)': {
			display: 'block',
		},
	},

	// Email badge styles
	emailBadges: {
		display: 'flex',
		gap: spacing.xs,
	},
	emailBadgeContainer: {
		alignItems: 'center',
		background: colors.background.dark,
		width: 'fit-content',
		borderRadius: 5,
		display: 'flex',
		fontSize: 12,
		padding: 5,
		marginTop: 4,
	},
	emailBadgeCheckmarkIcon: {
		borderRadius: '50%',
		height: 18,
		marginRight: 8,
		position: 'relative',
		width: 18,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},

	// Email count badge for additional recipients
	emailCountBadge: {
		marginLeft: 4,
		color: colors.text.light,
		cursor: 'help',
		fontSize: 12,
		fontWeight: 500,
	},

	// Action menu container
	actionMenuContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},

	// Email badge dynamic colors (these will be overridden with inline styles)
	emailBadgeContainerWithHeader: {
		// This extends emailBadgeContainer but allows for dynamic header color
	},
	emailBadgeCheckmarkIconWithTint: {
		// This extends emailBadgeCheckmarkIcon but allows for dynamic tint color
	},

	// HoverCard styles for machine opened disclosure
	hoverCardTrigger: {
		display: 'inline-flex',
		alignItems: 'center',
		cursor: 'pointer',
		background: 'transparent',
		border: 'none',
		padding: 0,
		marginLeft: spacing.xs,
	},
	hoverCardContent: {
		maxWidth: 300,
		fontSize: 14,
		lineHeight: 1.5,
	},
});
